import React, {Component} from 'react';
import {Navigate} from 'react-router-dom';
import {LayoutSidebar} from "../../Layout";
import {ClientAlertsView} from "./panel_v11/alerts/ClientAlertsView";
import {bitacoraAlertsPath} from "./panel_v11/alerts/clientAlertsPaths";
import {useFicha21} from "../../context/UserModulesContext";
import {withRouterParams} from "../../utils/withRouterParams";

// Guard de /client/:id/alerts (la pantalla de Alertas del cliente, card j61xJLod). Es de la ficha
// 2.1: sin ella se sigue yendo adonde iba el tile hasta ahora, la Bitácora filtrada en alertas.
//
// Hasta que llegan los módulos no se decide nada: redirigir con el flag todavía en false rebotaría
// a un usuario 2.1 por un valor que no llegó (mismo patrón que ClientLines).
function AlertsGuard({clientId}) {
    const {ficha21, loaded} = useFicha21();

    if (!loaded) return null;
    if (!ficha21) return <Navigate to={bitacoraAlertsPath(clientId)} replace/>;

    return <ClientAlertsView clientId={clientId}/>;
}

class ClientAlertsComponent extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <AlertsGuard clientId={this.props.match.params.id}/>
            </div>
        );
    }
}

export default withRouterParams(ClientAlertsComponent);
